import Model from 'models/Model';
import Product from '../product/Model.Product';
import productPricingAutomationRuleDeleteApi from './delete/Api.ProductPricingAutomationRule.Delete';
import productPricingAutomationRuleListApi from './list/Api.ProductPricingAutomationRule.List';
import productPricingAutomationRuleSaveApi from './save/Api.ProductPricingAutomationRule.Save';

export default class ProductPricingAutomationRule
  extends Model<Model.IProductPricingAutomationRule>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductPricingAutomationRule>
{
  id: number;
  logicalLayout: Model.Automation.ILayoutToken[];
  expressions: Model.Automation.IExpression[];
  effects: Model.Automation.IEffect[];

  productId: number;
  product: Product;

  constructor(
    data: Partial<Model.IProductPricingAutomationRule> | Utils.FormData<Model.IProductPricingAutomationRule>,
    language?: Locale.Languages
  ) {
    super(
      {
        product: Product,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id.toString(),
    };
  }
  static async list(body?: Api.Core.ProductPricingAutomationRule.List.IRequest) {
    const { payload, ...rest } = await productPricingAutomationRuleListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ProductPricingAutomationRule(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await productPricingAutomationRuleSaveApi(this);
  }
  async delete() {
    return await productPricingAutomationRuleDeleteApi(this.id);
  }
}
